<ng-container *ngIf="showContent">
  <div id="myModal" class="neo-modal">
    <div class="neo-modal-content">
      <!-- <iframe width="100%" height="100%" title="privacy-policy" [attr.src]="urlSafe"></iframe> -->
      <div class="neo-button-container">
        <p class="m-0">
          <span class="custom text">Please read the <span (click)="termofuse()">Terms of Use</span> and  <span (click)="showBconePrivacyPolicy()"> Privacy Policy</span>.
          Please either click Accept to agree to them and to consent to Bristlecone’s receiving and using your personal
           information to give you access to the Bristlecone NEO® Platform, or Decline.
           If you decline, you will not be permitted to use the Bristlecone NEO® Platform.</span>
          <button class="button button-accept" (click)="accept()">Accept</button>
          <button class="button button-cancel" (click)="cancel()">Decline</button>
        </p>
      </div>
    </div>
  </div>
</ng-container>
